import { gsap } from 'gsap';
import Swiper from 'swiper';
import { Autoplay } from 'swiper/modules';
import { lg, md, sm, wide, xl, xl2, xwide } from '../common';
import { attachVisibilityBasedToggler } from '../lib/autoplayVisibilityBasedToggler';

export function initPromoHero(parent) {
  if (!parent) return;

  const swipers = parent.querySelectorAll('.swiper');
  swipers.forEach((swiper) => {
    const swiperInstance = new Swiper(swiper, {
      modules: [Autoplay],
      loop: true,
      centeredSlides: true,
      slidesPerView: 'auto',
      spaceBetween: 20,
      autoplay: { delay: 3000 },
      breakpoints: {
        [sm]: { spaceBetween: 20 },
        [md]: { spaceBetween: 20 },
        [xl]: { spaceBetween: 24 },
        [xl2]: { spaceBetween: 24 },
        [wide]: { spaceBetween: 28 },
        [xwide]: { spaceBetween: 32 },
      },
    });
    attachVisibilityBasedToggler(swiper, swiperInstance);
  });

  const cards = parent.querySelectorAll('.promo-hero__card');
  cards.forEach((card, index) => {
    gsap.set(card, {
      opacity: 0,
      scale: 0.8,
      transformOrigin: 'center center',
    });

    const tl = gsap.timeline({ delay: 0.6 });

    const nums = card.querySelectorAll('[data-counter-to]');
    nums.forEach((num) => {
      const to = parseInt(num.dataset.counterTo, 10);
      tl.counter(
        num,
        {
          end: to,
          increment: 1,
          duration: 0.75,
        },
        '<',
      );
    });

    tl.to(
      card,
      {
        opacity: 1,
        scale: 1.02,
        duration: 0.5,
        ease: 'power1.out',
        delay: index * 0.1,
      },
      '<',
    );
    tl.to(card, {
      scale: 1,
      duration: 0.3,
      ease: 'power1.inOut',
    });
  });
}

export function initAllPromoHeroes() {
  const blocks = document.querySelectorAll('.js-promo-hero');
  blocks.forEach((block) => initPromoHero(block));
}
